// import React, { Component } from "react";
// import { Breadcrumb } from "@gull";
// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from "react-bootstrap-table2-paginator";
// //import overlayFactory from "react-bootstrap-table2-overlay";
// import { Row, Col, DropdownButton, Dropdown, Spinner } from "react-bootstrap";
// import memberService from "app/services/memberService";
// import queryString from "app/services/queryStringService";
// import _ from "lodash";
// import { AiFillFileExcel } from "react-icons/ai";
// import Swal from "sweetalert2";
// import { format } from "date-fns";
// import { Helmet } from "react-helmet";
// import { Link } from "react-router-dom";
// import { Accordion, Button, Card } from "react-bootstrap";
// import SearchService from "app/services/SearchService";
// import paymentService from "app/services/paymentService";
// import moment from "moment";
// import {
//   MdEdit,
//   MdDelete,
//   MdAccountBalanceWallet,
//   MdDone,
//   MdClear,
// } from "react-icons/md";
// const {
//   getrequisition,
//   approveReq,
//   declineReq,
//   approveReqByDistributor,
//   declineReqByDistributor,
// } = paymentService;
// class PendingReq extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       page: 1,
//       data: [],
//       sizePerPage: 10,
//       dataCount: 0,
//       loading: true,
//       memId: 0,
//       FromDate: "",
//       ToDate: "",
//       TransactionMode: "",
//       status: "Pending",
//     };
//   }

//   transactionAmountFormatter = (cell, row) => {
//     return <span> ₹ {row.amount} </span>;
//   };
//   transactionModeFormatter = (cell, row) => {
//     return <span>{row.transferMethod?.toUpperCase()} </span>;
//   };
//   dateFormater = (cell, row) => {
//     return new moment(cell ? cell : new Date()).format("MMMM Do YYYY, hh:mm a");
//   };
//   actionFormatter = (cell, row) => {
//     //  console.log(row)
//     if (row.status == "Pending") {
//       return (
//         <DropdownButton variant="outline-primary" title="Action" size="sm">
//           <Dropdown.Item
//             href="#"
//             onClick={() => {
//               Swal.fire({
//                 title: `<h1>Approve Credit </h1>`,
//                 html: `<input type="hidden" id="hdnReqId" name="hdnReqId" value=${row.id}>
//                 <textarea style="height:100px;resize:none" id="Reqremarkid" name="Reqremarkid" placeholder="Remark ..." class="swal2-input form-control"></textarea>

//                       </div>`,

//                 showCancelButton: true,
//                 confirmButtonText: "Approve",
//                 cancelButtonText: "Back",
//                 showLoaderOnConfirm: true,
//                 allowOutsideClick: false,
//                 preConfirm: async () => {
//                   const data = {
//                     requisitionId: document.getElementById("hdnReqId").value,
//                     remark: document.getElementById("Reqremarkid").value,
//                   };
//                   const res = await approveReqByDistributor(data);
//                   //  console.log(res);
//                   return res;
//                 },
//               }).then(async (result) => {
//                 if (result.isConfirmed) {
//                   if (result.value.status == "Success") {
//                     Swal.fire({
//                       icon: "success",
//                       text: "Requisition approved successfully",
//                     });
//                     await this.loadTransaction();
//                   } else {
//                     Swal.fire({
//                       icon: "error",
//                       text: "Requisition failed",
//                     });
//                   }
//                 }
//               });
//             }}
//           >
//             <MdDone className="text-success mr-4" size={15}></MdDone>
//             Appove
//           </Dropdown.Item>
//           <Dropdown.Item
//             onClick={() => {
//               Swal.fire({
//                 title: `Decline Requisition `,
//                 html: `<input type="hidden" id="declineMemberId" value="${row.id}" />
//                 <textarea style="height:100px;resize:none" id="declineremark" placeholder="Remark ..." class="swal2-input form-control">`,

//                 showCancelButton: true,
//                 confirmButtonText: "Decline",
//                 cancelButtonText: "Back",
//                 showLoaderOnConfirm: true,
//                 allowOutsideClick: false,
//                 preConfirm: async () => {
//                   const data = {
//                     requisitionId:
//                       document.getElementById("declineMemberId").value,
//                     remark: document.getElementById("declineremark").value,
//                   };
//                   const res = await declineReqByDistributor(data);
//                   console.log(res);
//                   return res;
//                 },
//               }).then((result) => {
//                 if (result.isConfirmed) {
//                   if (result.value.status === "Success") {
//                     Swal.fire({
//                       title: result.value.message,
//                       text: "Requisition Declined successfully",
//                       icon: "success",
//                     });
//                   } else {
//                     Swal.fire("Error occured");
//                   }
//                 }
//               });
//             }}
//           >
//             <MdClear size={15} className="text-danger mr-4"></MdClear>
//             Decline
//           </Dropdown.Item>
//         </DropdownButton>
//       );
//     }
//   };
//   columns = [
//     {
//       dataField: "transactionId",
//       text: "Transaction Id",
//       headerStyle: (colum, colIndex) => {
//         return { textAlign: "center" };
//       },
//     },
//     {
//       dataField: "fromMember.company",
//       text: "From",
//       headerStyle: (colum, colIndex) => {
//         return { width: "150px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "referenceNo",
//       text: "Ref. Number",
//       headerStyle: (colum, colIndex) => {
//         return { textAlign: "center" };
//       },
//     },
//     {
//       dataField: "requestDate",
//       text: "Req Date and Time",
//       formatter: this.dateFormater,
//       headerStyle: (colum, colIndex) => {
//         return { width: "250px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "pgType",
//       text: "Req Type",
//       headerStyle: (colum, colIndex) => {
//         return { width: "150px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "transferMethod",
//       text: "Payment Mode",
//       formatter: this.transactionModeFormatter,
//       headerStyle: (colum, colIndex) => {
//         return { width: "150px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "amount",
//       text: "Amount",
//       formatter: this.transactionAmountFormatter,
//       headerStyle: (colum, colIndex) => {
//         return { width: "150px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "status",
//       text: "Status",
//       headerStyle: (colum, colIndex) => {
//         return { textAlign: "center" };
//       },
//     },
//     {
//       dataField: "memId",
//       text: "Action",
//       headerStyle: (colum, colIndex) => {
//         return { width: "100px", textAlign: "center" };
//       },
//       formatter: this.actionFormatter,
//     },
//   ];
//   rowStyle = (row, rowIndex) => {
//     const style = {};
//     style.textAlign = "center";
//     style.fontWeight = "600";
//     style.verticalAlign = "center";
//     return style;
//   };
//   NoDataIndication = () => {
//     const { loading } = this.state;
//     //alert(loading);
//     if (loading) {
//       return (
//         <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
//       );
//     } else {
//       return (
//         <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
//           <span className="align-middle"></span>
//           <p> No Data Found</p>
//         </div>
//       );
//     }
//   };

//   loadTransaction = async () => {
//     const { page, sizePerPage, FromDate, ToDate, TransactionMode, status } =
//       this.state;
//     const query = queryString.getQueryStringFromObj({
//       pageNumber: page,
//       pageSize: sizePerPage,
//       FromDate,
//       ToDate,
//       TransactionMode,
//       status: "Pending",
//     });
//     if (this.state.dataCount !== 0) {
//       this.setState({ loading: true });
//     }
//     const response = await getrequisition(query);
//     const data = response.data.data;
//     const paggingData = JSON.parse(response.headers["x-pagination"]);
//     this.setState({
//       loading: false,
//       data,
//       dataCount: paggingData.TotalCount,
//       page: paggingData.CurrentPage,
//       sizePerPage: paggingData.PageSize,
//     });
//   };

//   async componentDidMount() {
//     await this.loadTransaction();
//   }

//   handleTableChange = async (type, { page, sizePerPage }) => {
//     const currentIndex = (page - 1) * sizePerPage;
//     this.setState(() => ({
//       page,
//       sizePerPage,
//     }));
//     setTimeout(async () => {
//       await this.loadTransaction();
//     }, 10);
//   };

//   handleSearch = async () => {
//     this.setState(() => ({
//       page: 1,
//       sizePerPage: 10,
//     }));

//     setTimeout(async () => {
//       await this.loadMember();
//     }, 10);
//   };

//   handleExport = async () => {
//     this.setState(() => ({
//       page: 1,
//       sizePerPage: 10,
//     }));

//     setTimeout(async () => {
//       await this.exportMember();
//     }, 10);
//   };

//   render() {
//     const { data, sizePerPage, page, dataCount, loading, status } = this.state;

//     const sizePerPageRenderer = ({
//       options,
//       currSizePerPage,
//       onSizePerPageChange,
//       status,
//     }) => (
//       <>
//         <label className="mr-2">Page Size </label>
//         <div className="btn-group mr-4" role="group">
//           {options.map((option) => {
//             const isSelect = currSizePerPage === `${option.page}`;
//             return (
//               <button
//                 key={option.text}
//                 type="button"
//                 onClick={() => onSizePerPageChange(option.page)}
//                 className={`btn btn-sm ${
//                   isSelect ? "btn-primary" : "btn-secondary"
//                 }`}
//               >
//                 {option.text}
//               </button>
//             );
//           })}
//         </div>
//       </>
//     );

//     const paginationOptions = {
//       paginationSize: 5,
//       pageStartIndex: 1,
//       firstPageText: "First",
//       prePageText: "Back",
//       nextPageText: "Next",
//       lastPageText: "Last",
//       nextPageTitle: "First page",
//       prePageTitle: "Pre page",
//       firstPageTitle: "Next page",
//       lastPageTitle: "Last page",
//       showTotal: true,
//       totalSize: dataCount,
//       sizePerPageList: [
//         {
//           text: "10",
//           value: 10,
//         },
//         {
//           text: "15",
//           value: 15,
//         },
//         {
//           text: "20",
//           value: 20,
//         },
//         {
//           text: "50",
//           value: 50,
//         },
//       ],
//       sizePerPageRenderer,
//     };

//     return (
//       <>
//         <Helmet>
//           <title>Pending Requisition</title>
//         </Helmet>
//         <Breadcrumb
//           routeSegments={[{ name: "Pending Requisition" }]}
//         ></Breadcrumb>
//         <div className="mb-3">
//           <BootstrapTable
//             hover
//             remote
//             keyField="uniqueIdentity"
//             data={data}
//             columns={this.columns}
//             pagination={paginationFactory(paginationOptions)}
//             onTableChange={this.handleTableChange}
//             noDataIndication={() => <this.NoDataIndication />}
//             headerClasses="bg-primary text-white"
//             bodyClasses="react-bootstrap-table-next-min-height"
//             rowStyle={this.rowStyle}
//           />
//         </div>
//       </>
//     );
//   }
// }
// export default PendingReq;
import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { DropdownButton, Dropdown } from "react-bootstrap";

import queryString from "app/services/queryStringService";
import _ from "lodash";
import { MdDone, MdClear } from "react-icons/md";

import Swal from "sweetalert2";
import { format } from "date-fns";
import { Helmet } from "react-helmet";
import moment from "moment";

import {
  getrequisition,
  approveReqByDistributor,
  declineReqByDistributor,
} from "app/services/paymentService";
import HandyScroll from "app/common/Scroll";

const PendingReq = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const transactionAmountFormatter = (cell, row) => {
    return <span> ₹ {row.amount} </span>;
  };
  const transactionModeFormatter = (cell, row) => {
    return <span>{row.transferMethod?.toUpperCase()} </span>;
  };
  const dateFormater = (cell, row) => {
    return moment(cell ? cell : new Date()).format("MMMM Do YYYY, hh:mm a");
  };
  const actionFormatter = (cell, row) => {
    if (row.status == "Pending") {
      return (
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item
            href="#"
            onClick={() => {
              Swal.fire({
                title: `<h1>Approve Credit </h1>`,
                html: `<input type="hidden" id="hdnReqId" name="hdnReqId" value=${row.id}>
                  <textarea style="height:100px;resize:none;width:80%" id="Reqremarkid" name="Reqremarkid" placeholder="Remark ..." class="swal2-input form-control"></textarea>

                        </div>`,

                showCancelButton: true,
                confirmButtonText: "Approve",
                cancelButtonText: "Back",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  const data = {
                    requisitionId: document.getElementById("hdnReqId").value,
                    remark: document.getElementById("Reqremarkid").value,
                  };
                  const res = await approveReqByDistributor(data);
                  //  console.log(res);
                  return res;
                },
              }).then(async (result) => {
                if (result.isConfirmed) {
                  if (result.value.status == "Success") {
                    Swal.fire({
                      icon: "success",
                      text: "Requisition approved successfully",
                    });
                    await loadReq();
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: result.value.message,
                    });
                  }
                }
              });
            }}
          >
            <MdDone className="text-success mr-4" size={15}></MdDone>
            Appove
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              Swal.fire({
                title: `Decline Requisition `,
                html: `<input type="hidden" id="declineMemberId" value="${row.id}" />
                  <textarea style="height:100px;resize:none;width:80%" id="declineremark" placeholder="Remark ..." class="swal2-input form-control">`,

                showCancelButton: true,
                confirmButtonText: "Decline",
                cancelButtonText: "Back",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  const data = {
                    requisitionId:
                      document.getElementById("declineMemberId").value,
                    remark: document.getElementById("declineremark").value,
                  };
                  const res = await declineReqByDistributor(data);
                  console.log(res);
                  return res;
                },
              }).then(async (result) => {
                if (result.isConfirmed) {
                  if (result.value.status === "Success") {
                    Swal.fire({
                      title: result.value.message,
                      text: "Requisition Declined successfully",
                      icon: "success",
                    });
                    await loadReq();
                  } else {
                    Swal.fire("Error occurred");
                  }
                }
              });
            }}
          >
            <MdClear size={15} className="text-danger mr-4"></MdClear>
            Decline
          </Dropdown.Item>
        </DropdownButton>
      );
    }
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const columns = [
    {
      dataField: "transactionId",
      text: "Transaction Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "fromMember.company",
      text: "From",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "referenceNo",
      text: "Ref. Number",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "requestDate",
      text: "Req Date and Time",
      formatter: dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "250px", textAlign: "center" };
      },
    },
    {
      dataField: "pgType",
      text: "Req Type",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transferMethod",
      text: "Payment Mode",
      formatter: transactionModeFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: transactionAmountFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "memId",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadReq = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      status: "Pending",
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getrequisition(query);
    const TableData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setLoading(false);
    setData(TableData);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };
  useEffect(() => {
    loadReq();
  }, [page, sizePerPage]);

  return (
    <>
      <Helmet>
        <title>Pending Requisition List</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Pending Requisition List" }]}
      ></Breadcrumb>
      <HandyScroll>
        <div
          class="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={columns}
            pagination={dataCount > 0 && paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
    </>
  );
};

export default PendingReq;
